import logo from '../assets/logo.png';
import banner from '../assets/banner.jpg'; // Tu banner

const Header = () => (
  <header className="relative w-full h-[300px] md:h-[400px] bg-cover bg-center bg-no-repeat shadow-lg overflow-hidden" style={{ backgroundImage: `url(${banner})` }}>
    <div className="absolute inset-0 bg-gradient-to-br from-primary-900/90 via-primary-800/80 to-transparent"></div>

    <style>
      {`
        @keyframes floatUp {
          0% { opacity: 0; transform: translateY(20px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        .animate-float-up {
          animation: floatUp 1s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }
        @keyframes expandWidth {
          0% { width: 0; opacity: 0; }
          100% { width: 4rem; opacity: 1; }
        }
        .animate-expand {
          animation: expandWidth 1s cubic-bezier(0.16, 1, 0.3, 1) 0.5s forwards;
        }
      `}
    </style>

    <div className="relative z-10 container mx-auto px-4 h-full flex flex-col">
      {/* Top Left Logo */}
      <div className="pt-6">
        <a href="https://calz.org.ar" target="_blank" rel="noopener noreferrer" className="inline-block hover:opacity-80 transition-transform hover:scale-105 duration-300">
          <img src={logo} alt="Logo CALZ" className="h-24 md:h-32 w-auto object-contain brightness-0 invert drop-shadow-md" />
        </a>
      </div>

      {/* Centered Title */}
      <div className="flex-grow flex items-center justify-center pb-12">
        <div className="text-center animate-float-up">
          <h1 className="text-5xl md:text-7xl font-extrabold text-white tracking-tight">
            Buscador CALZ
          </h1>
          <div className="h-1 bg-white/70 mx-auto mt-6 rounded-full w-0 opacity-0 animate-expand"></div>
        </div>
      </div>
    </div>
  </header>
);
export default Header;
